import Layout from "../components/Layout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { HelpCircle } from "lucide-react";

const FAQsPage = () => {
  const faqs = [
    {
      category: "Sobre la Plataforma",
      questions: [
        {
          q: "¿Qué es Reutiliza Majadahonda?",
          a: "Reutiliza Majadahonda es una iniciativa del Ayuntamiento de Majadahonda para impulsar la economía circular mediante el intercambio de objetos entre ciudadanos. Podrás dejar objetos que ya no utilices y obtener otros que te interesen. A través del catálogo de la plataforma, se pueden conocer y reservar los productos disponibles, y añadir nuevos objetos."
        },
        {
          q: "¿Cómo me registro?",
          a: "Ve a \"Regístrate\" y rellena el formulario con tus datos (nombre, DNI/NIE, dirección en Majadahonda). También puedes registrarte con tu cuenta de Google. Recibirás un email de confirmación y ya podrás reservar productos en el Catálogo y añadir objetos."
        },
        {
          q: "¿Tengo que pagar algo?",
          a: "No. Reutiliza Majadahonda funciona con un sistema de puntos. Los usuarios registrados podrán acumular puntos y canjearlos por objetos sin ningún coste."
        }
      ]
    },
    {
      category: "Sistema de Puntos",
      questions: [
        {
          q: "¿Cómo consigo puntos?",
          a: "Puedes conseguir puntos de las siguientes formas:\n• Al realizar el registro en la web: 100 puntos\n• Al entregar un objeto: 100 puntos\n• Al retirar un objeto: se restan 50 puntos"
        }
      ]
    },
    {
      category: "Añadir Productos",
      questions: [
        {
          q: "¿Cómo añado un producto?",
          a: "1. Ve a \"Añadir producto\"\n2. Sube una foto y descripción del objeto que quieras depositar y publícalo\n3. El equipo técnico validará tu producto\n4. Una vez aprobado, lleva el objeto al Punto Limpio de Majadahonda\n5. Identifícate con tu usuario o correo electrónico al gestor del punto limpio, que validará el objeto y quedará disponible para otro usuario"
        },
        {
          q: "¿Cuántos objetos puedo depositar?",
          a: "Se podrán depositar un máximo de 10 unidades al mes. Se entiende como unidad un único objeto o grupo de objetos que conformen una unidad (una colección de libros, una vajilla, etc.)."
        }
      ]
    },
    {
      category: "Reservar Productos",
      questions: [
        {
          q: "¿Cómo reservo un objeto?",
          a: "1. Ve al \"Catálogo de objetos\"\n2. Reserva el objeto deseado\n3. Acude al Punto Limpio donde se encuentra el objeto reservado en un plazo de 48 horas\n4. Identifícate con tu usuario o correo electrónico al gestor del punto, quien te entregará el objeto"
        },
        {
          q: "¿Cuánto tiempo tengo para recoger un objeto reservado?",
          a: "Una vez realizada la reserva, dispones de 48 horas para recoger el objeto en el Punto Limpio. Recibirás un email recordatorio antes de que expire el plazo."
        },
        {
          q: "¿Qué pasa si no acudo a recoger el objeto reservado?",
          a: "Si no recoges el objeto dentro del plazo indicado, se cancelará automáticamente la reserva y el objeto volverá a estar disponible para otros usuarios."
        },
        {
          q: "¿Puedo reservar varios objetos?",
          a: "Sí, puedes reservar un máximo de 5 unidades a la vez. Se entiende como unidad un único objeto o grupo de objetos que conformen una unidad."
        },
        {
          q: "¿Puedo cancelar una reserva?",
          a: "Sí. Puedes cancelar una reserva desde la sección \"Mis Reservas\" si no puedes recoger el objeto a tiempo."
        }
      ]
    },
    {
      category: "Tipos de Productos",
      questions: [
        {
          q: "¿Qué productos puedo llevar?",
          a: "Puedes llevar:\n• Muebles pequeños y medianos (mesas, sillas, estanterías)\n• Artículos de deporte y ocio\n• Juguetes y accesorios infantiles\n• Artículos del hogar (decoración, menaje)\n• Libros y material educativo\n• Bicicletas\n\nTodos los productos deben estar en buen estado de uso y funcionamiento."
        },
        {
          q: "¿Qué productos NO están permitidos?",
          a: "NO está permitido el intercambio de:\n\n❌ Sofás y muebles muy voluminosos\n❌ Electrodomésticos grandes (neveras, lavadoras, lavavajillas)\n❌ Aparatos eléctricos y electrónicos (RAEE)\n❌ Ropa y calzado\n❌ Alimentos, bebidas y plantas\n❌ Productos en mal estado o rotos\n❌ Artículos peligrosos o ilegales\n\n⚠️ Nota sobre RAEE: Los residuos de aparatos eléctricos y electrónicos (neveras, lavadoras, etc.) deben gestionarse a través del Punto Limpio como residuos especiales, no a través de esta plataforma. Recuerda que las tiendas tienen la obligación de retirar tu electrodoméstico viejo cuando compras uno nuevo."
        }
      ]
    },
    {
      category: "Ubicación y Horarios",
      questions: [
        {
          q: "¿Dónde puedo intercambiar mis productos?",
          a: "En el Punto Limpio de Majadahonda, ubicado en:\n\n📍 Carretera de El Plantío, 47\n28221 Majadahonda, Madrid\n\nGestionado por Valoriza Servicios Medioambientales."
        },
        {
          q: "¿En qué horario puedo acudir?",
          a: "El horario de atención al público es:\n\n• Lunes a viernes: 15:00 - 20:00 h\n• Sábados: 08:00 - 20:00 h\n• Domingos y festivos: 09:00 - 14:00 h\n\n🚫 Cerrado: 25 de diciembre, 1 y 6 de enero"
        },
        {
          q: "¿Puedo acceder con mi vehículo?",
          a: "Sí, puedes acceder en tu vehículo, pero solo debes permanecer el tiempo necesario para la carga y descarga de productos."
        }
      ]
    },
    {
      category: "Otras Preguntas",
      questions: [
        {
          q: "¿Solo pueden usar la plataforma vecinos de Majadahonda?",
          a: "Sí, la plataforma está destinada únicamente a residentes de Majadahonda. Por eso solicitamos el DNI/NIE y verificamos que el código postal sea de Majadahonda (28220, 28221 o 28222) durante el registro."
        },
        {
          q: "¿Cómo recojo un objeto reservado?",
          a: "Una vez recibido el email con el producto reservado, acude al Punto Limpio y muestra tu DNI al personal. Ellos comprobarán que el DNI se corresponde con la reserva y te entregarán el objeto."
        }
      ]
    }
  ];

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#69C7EA]/20 rounded-full mb-4">
            <HelpCircle className="w-8 h-8 text-[#374B67]" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-[#374B67] mb-2" data-testid="faqs-title">
            Preguntas Frecuentes
          </h1>
          <p className="text-slate-600">
            Encuentra respuestas a las dudas más comunes sobre Reutiliza Majadahonda
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((section, sectionIndex) => (
            <Card key={sectionIndex} className="border-0 shadow-md">
              <CardHeader className="pb-0">
                <CardTitle className="text-lg text-[#374B67]">{section.category}</CardTitle>
              </CardHeader>
              <CardContent className="pt-4">
                <Accordion type="single" collapsible className="w-full">
                  {section.questions.map((faq, faqIndex) => (
                    <AccordionItem key={faqIndex} value={`${sectionIndex}-${faqIndex}`}>
                      <AccordionTrigger className="text-left hover:text-[#374B67]">
                        {faq.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-slate-600 whitespace-pre-line">
                        {faq.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default FAQsPage;
